// extracted by mini-css-extract-plugin
export default {"container":"RootWorkspace_container__DG0VP"};